<template>
  <div>
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        videos
      </h1>
    </div>
    <div class="pb-6" v-if="ready">
      <div class="flex justify-center items-center mb-4">
        <label class="mr-2 font-bold">
          Year:
        </label>
        <div class="w-20">
          <select class="form-select
                block
                w-full
                px-3
                py-1.5
                text-base
                font-normal
                text-gray-700
                bg-white bg-clip-padding bg-no-repeat
                border border-solid border-gray-300
                rounded
                transition
                ease-in-out
                m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"
                v-model="year" @change="getVideosByYear()">
            <option v-for="item in years" :value="item">{{item}}</option>
          </select>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="flex justify-items-center w-100 mb-4 md:mb-8 px-2 md:px-0 main_slider">
          <swiper
              class="md:mt-0 "
              :modules="[Navigation, Scrollbar, A11y, Thumbs]"
              :slides-per-view="1"
              :space-between="50"
              :navigation="{ clickable: true }"
              :thumbs="{ swiper: thumbsSwiper }"
          >
            <swiper-slide v-for="item in videos">
              <h2 class="text-3xl text-center mb-2">{{item.title}}</h2>
              <template v-if="item.video_url">
                <iframe v-if="videos.length > 0" :title="item.title" class="mx-auto max-w-[1500px] h-[350px] sm:h-[400px] md:h-[600px] xl:h-[800px]" :src="'https://www.youtube.com/embed/'+ item.video_source_id" width="100%" height="auto"
                        frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen/>
              </template>
              <template v-if="item.video_embeded">
                <div v-html="item.video_embeded" class="flex justify-center"></div>
              </template>

            </swiper-slide>
          </swiper>
        </div>
        <div class="swiper-container px-2 md:px-0 small_slider max-w-full sm:max-w-[600px] mx-auto sm:min-w-[500px]">
          <swiper
              class="md:mt-0"
              :modules="[Navigation, Scrollbar, A11y, Thumbs]"
              :slides-per-view="videos.length > 3 ? 3 : videos.length "
              :space-between="25"
              :navigation="{ clickable: true }"
              watch-slides-progress
              @swiper="setThumbsSwiper"
          >
            <swiper-slide v-for="item in videos" class=" w-48" >
              <img v-if="item.thumbnail" class="h-100 w-full object-cover md:h-full w-full  w-48" width="120"  :src="item.thumbnail" :alt="item.title">
              <img v-else class="h-100 w-full object-cover md:h-full w-48" width="120"  src="/no-image-icon.png" :alt="item.title">
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadersSpinner />
    </div>
  </div>
</template>

<script setup>
import {ref, watch} from 'vue';
import {http} from "~/utils/http";
import { Navigation, Scrollbar, A11y, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
const videos = ref([]);
const years = ref([]);
const year = ref();
const current_year = ref(new Date().getFullYear());
const ready = ref(false);
const thumbsSwiper = ref(null);
const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};

const getVideosByYear = async () => {
  try {
    await http
        .get("/api/video",{
          params: {
            year: year.value
          }
        })
        .then((response) => {
          videos.value = response.data.videos;
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
}

const getVideos = async () => {
  try {
    await http
        .get("/api/video",{
          params: {
            year: current_year.value
          }
        })
        .then(async (response) => {
          videos.value = response.data.videos;
          years.value = response.data.years;
          let check = years.value.indexOf(current_year.value);
          if (check < 0) {
            current_year.value = years.value[0];
            await getVideos();
            return
          }
          year.value = current_year.value;
        });
    ready.value = true;
  } catch (e) {
    console.log(e.response.data.error);
  }
};

getVideos();
</script>

<style>


@media (min-width:1200px) {
  .main_slider .swiper-button-next{
    right: 8vw;
  }
  .main_slider .swiper-button-prev{
    left: 8vw;
  }
}

@media (min-width: 767px) and (max-width: 1199.89px) {
  .main_slider .swiper-button-next{
    right: 30px;
  }
  .main_slider .swiper-button-prev{
    left: 30px;
  }
}

@media (min-width: 576px) and (max-width: 766.89px) {
  .main_slider .swiper-button-next{
    right: 70px;
  }
  .main_slider .swiper-button-prev{
    left: 70px;
  }
}


@media (min-width:1400px) {

  .small_slider .swiper-button-next{
    right: 50px;
  }
  .small_slider .swiper-button-prev{
    left: 10px;
  }
}
@media (max-width:1199.89px) {
  .small_slider .swiper-button-prev:after, .small_slider  .swiper-button-next:after{
    font-size: 20px;
  }
}
@media (max-width:575.89px) {
  .main_slider .swiper-button-next{
    right: 10px;
  }
  .main_slider .swiper-button-prev{
    left: 10px;
  }
  .swiper-button-prev:after,  .swiper-button-next:after{
    font-size: 20px;
  }
}


</style>
